import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "../app.service";
import { Role } from "../common/enums";

@Component({
    selector: 'main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.css'],
    standalone: false
})
export class MainComponent implements OnInit {
  cloudRole = false;
  fieldRole = false;
  adminRole = false;

  constructor(private router: Router, protected app: AppService) {}

  ngOnInit(): void {    
    this.app.isLoggedInCheck().then(() => {
      const cloudRole = this.app.userHasRole(Role.Cloud);
      const fieldRole = this.app.userHasRole(Role.Field);
      const adminRole = this.app.userHasRole(Role.Admin);

      // navigate first and if no need only then make buttons visible to the user
      if (fieldRole && !adminRole && !cloudRole) {
        this.router.navigate(['field']);
      } else if (cloudRole && !adminRole && !fieldRole) {
        this.router.navigate(['RRC']);
      } else {
        this.cloudRole = cloudRole;
        this.fieldRole = fieldRole;
        this.adminRole = adminRole;
      }
    });
  }

  navigateToField() {
    this.router.navigate(['field']);
  }

  navigateToCloud() {
    this.router.navigate(['RRC']);
  }

  logout() {
    this.app.logout();
  }

  passwordChange() {
    this.router.navigate(['password-change']);
  }
}